import _ from 'lodash';
import { TRANSCODING_STATUSES, CHANNEL_TYPES, } from '@wix/wix-vod-constants/common';
import { keysToCamelCase } from '@wix/wix-vod-shared/common';
import { normalizeId } from '../normalizers/entity-id';
import { parseVideoItem } from './video-item';
const mapTimestampToDate = (channel, targetKey) => {
    channel[targetKey] = new Date(channel[targetKey] * 1000);
};
const mapStatsInfo = (channel) => {
    // TODO: WHYYYY?
    if (channel.statsInfo) {
        channel.statsInfo = _.mapValues(channel.statsInfo, (list) => {
            // get rid of empty categories & tags
            const nonEmptyList = _.filter(list, (item) => Boolean(item.value));
            return _.uniqBy(nonEmptyList, 'value');
        });
    }
};
const cleanupVideoCountsForYoutubeFeed = (channel) => {
    // skip videosCount for youtube feed, should be done on BE
    if (channel.channelType !== CHANNEL_TYPES.CHANNEL) {
        delete channel.videosCount;
    }
};
const parseFeaturedItem = (channel) => {
    if (!channel.featuredItem) {
        return;
    }
    if (!channel.featuredItem.mediaStatus ||
        channel.featuredItem.mediaStatus === TRANSCODING_STATUSES.NONE) {
        delete channel.featuredItem;
        if (channel.videosCount) {
            channel.videosCount -= 1;
        }
        return;
    }
    if (channel.featuredItem.itemId) {
        // cleanup in new VOD backend version
        channel.featuredItem = parseVideoItem(channel.featuredItem);
    }
};
export const parseCatalogChannelBase = (channel) => {
    channel = _.cloneDeep(channel);
    channel = keysToCamelCase(channel);
    mapTimestampToDate(channel, 'createdTs');
    mapTimestampToDate(channel, 'externalCreatedTs');
    mapTimestampToDate(channel, 'updatedTs');
    mapStatsInfo(channel);
    channel.id = normalizeId(channel.itemId);
    channel.customCoverUrl = channel.customCoverUrl || null;
    channel.videosCount = channel.usedCount;
    channel.urlType = channel.urlType || '';
    channel.channelType = channel.channelType || CHANNEL_TYPES.CHANNEL;
    delete channel.itemId;
    delete channel.usedCount;
    delete channel.publishChanges;
    parseFeaturedItem(channel);
    cleanupVideoCountsForYoutubeFeed(channel);
    return channel;
};
//# sourceMappingURL=catalog-channel.js.map